import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Route guard used by every protected route. Blocks unauthenticated
 * traffic to /login and role-mismatched traffic to /.
 */
export default function Protected({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return <div className="min-h-screen flex items-center justify-center text-stone-500">Loading…</div>;
  }
  if (!user) return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

/** Minimal-branded fallback while a lazy chunk downloads. */
export function RouteFallback() {
  return (
    <div
      className="min-h-screen bg-warm flex items-center justify-center"
      data-testid="route-fallback"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="text-center">
        <div className="mx-auto h-10 w-10 rounded-full border-2 border-forest/20 border-t-forest animate-spin" />
        <div className="mt-3 text-xs uppercase tracking-widest text-stone-400">Loading…</div>
      </div>
    </div>
  );
}
